module.exports = __webpack_public_path__ + "img/toplogo.e228f01b.png";